import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState/onboardingState.ts';
import { IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

export const useHasDismissedNav4CollapseReminderSpotlight = (): {
	isNav4CollapseReminderSpotlightDismissed: any;
} => {
	const { data } = useGetOnboardingState([IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED]);

	const { isNav4CollapseReminderSpotlightDismissed } = deserializeState(data);

	return { isNav4CollapseReminderSpotlightDismissed };
};
